import {css} from '../../theme/css'
import {cssTheme} from '../theme'

export const classes = {
  noBorderListItem: css`
    ${cssTheme.default.day.line.token}: 0;
  `,
  noActionSelectItem: css`
    pointer-events: none;
  `,
}
